import { LeftHandSideMenuProps } from './LeftHandSideMenu.interfaces';
import { cn } from '@/utils';
import { useRef, type RefObject } from 'react';
import { useClickOutside } from '@netfront/ui-library';
import { useLeftHandSideMenu } from './LeftHandSidebarMenuProvider';
import LeftHandSideMenuTrigger from './LeftHandSidebarMenuTrigger';

export const LeftHandSideMenu = ({ children }: LeftHandSideMenuProps) => {
  const { isSidebarMenuOpen, toggleSidebarMenu } = useLeftHandSideMenu();
  const sidebarElement = useRef<HTMLElement>(null);
  useClickOutside(sidebarElement as RefObject<HTMLElement | undefined>, () => {
    if (isSidebarMenuOpen) {
      toggleSidebarMenu(false);
    }
  });

  return (
    <aside
      ref={sidebarElement}
      data-open={isSidebarMenuOpen}
      className={cn('absolute h-full w-11/12 max-w-80 bg-secondary z-10 left-0 transition-200 kanzi-no-print c-left-hand-side-menu')}
    >
      <LeftHandSideMenuTrigger className="none sm:flex absolute right-0 translate-x-50 top-24 bg-transparent" />

      <div className="overflow-y-auto h-full py-16 p-8 w-full">{children}</div>
    </aside>
  );
};
